import React from 'react';
import get from 'lodash/get';
import classNameBind from 'classnames/bind';
import formatData, { formatPercent } from '../../methods/formatData';
import styles from './TooltipContent.module.css';

const bindClasses = classNameBind.bind(styles);

const getColor = (entry) => {
  if (entry.color) {
    if (entry.color.indexOf('url(#gradient') === 0) {
      return entry.color.split('_')[2].slice(0, -1);
    }

    return entry.color;
  }

  return entry.payload.fill;
};

/* eslint-disable react/no-array-index-key */

const TooltipContent = ({
  payload,
  label,
  dateOnXAxis,
  chartType,
  compareMode,
  compareDivider,
  forceUnit,
  total,
  smallerTooltip,
  t,
  showWhiteSpace,
  hiddenContent,
}) => (
  hiddenContent
    ? (
      <div className={bindClasses('hidden-content-tooltip-wrapper')} data-ppuc-id="Chart.TooltipContent">
        {hiddenContent}
      </div>
    )
    : (
      <div
        className={bindClasses('tooltip-wrapper', chartType, { smallerTooltip })}
        data-ppuc-id="Chart.TooltipContent"
      >
        {
          get(payload, '[0].payload.numberOfAnnotations', 0) > 0 && (
            <div className={bindClasses('annotations-section')}>
              <div className={bindClasses('note-icon')} />
              <span className={bindClasses('annotations-number')}>{payload[0].payload.numberOfAnnotations}</span>
            </div>
          )
        }
        {label && (
          <div className={bindClasses('tooltip-label')}>
            {formatData(label, dateOnXAxis, true, false, t)}
          </div>
        )}
        {
          (payload || []).map((entry, index) => ([
            compareDivider > 0
            && (index % compareDivider) === 0
            && compareMode.length > (index / compareDivider)
              ? (
                <div className={bindClasses('segment-label', `lvl-${index / compareDivider}`)} key={index}>{compareMode[index / compareDivider]}</div>
              ) : null,
            <div className={bindClasses('tooltip-entry')} key={`item-${index}`} data-ppuc-id="TooltipEntry">
              {(entry.color || (entry.payload && entry.payload.fill)) && (
                <div
                  className={bindClasses('tooltip-entry-icon', chartType)}
                  style={{ backgroundColor: getColor(entry) }}
                />
              )}
              <div className={bindClasses('tooltip-entry-text')}>
                {entry.name}
              </div>
              <div className={bindClasses('tooltip-entry-value', { showWhiteSpace })}>
                {formatData(entry.value, false, false, false, t)}
                {forceUnit || entry.unit}
                {chartType === 'pie' && (
                  <span className={bindClasses('tooltip-entry-percent')}>
                    {` (${formatPercent(entry.value / total, t)})`}
                  </span>
                )}
              </div>
            </div>,
          ]))
        }
      </div>
    )
);

TooltipContent.defaultProps = {
  chartType: '',
  label: '',
  dateOnXAxis: false,
  compareDivider: 0,
  compareMode: [],
  forceUnit: null,
  total: null,
  showWhiteSpace: false,
};

export default TooltipContent;
